module.exports = __webpack_public_path__ + "static/media/images.c936217d.png";